export default __webpack_public_path__ + "static/media/check-onyx.d3dac6c4.svg";